(() => {
  if (window.__ovrdoseMobileNavV65) return;
  window.__ovrdoseMobileNavV65 = true;

  const drawerSelector = '.ovr-prelaunch-drawer__details';
  const root = document.documentElement;
  let activeDrawer = null;

  const setDrawerTop = (details) => {
    const header = details.closest('#header-component');
    const headerBottom = header?.getBoundingClientRect().bottom ?? 0;
    const visibleTop = Math.max(0, Math.round(headerBottom));
    details.style.setProperty('--ovr-mobile-drawer-top', `${visibleTop}px`);
  };

  const setExpandedState = (details, expanded) => {
    details.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(expanded));
  };

  const closeDrawer = (details) => {
    if (!details) return;
    details.open = false;
    setExpandedState(details, false);
    details.style.removeProperty('--ovr-mobile-drawer-top');
    if (activeDrawer === details) activeDrawer = null;
    root.classList.remove('ovr-mobile-nav-open');
  };

  const syncDrawer = (details) => {
    if (details.open) {
      if (activeDrawer && activeDrawer !== details) closeDrawer(activeDrawer);
      activeDrawer = details;
      setDrawerTop(details);
      setExpandedState(details, true);
      root.classList.add('ovr-mobile-nav-open');
      return;
    }

    if (activeDrawer === details) closeDrawer(details);
    else setExpandedState(details, false);
  };

  const bindDrawer = (details) => {
    if (details.dataset.ovrMobileNavBound === 'true') return;
    details.dataset.ovrMobileNavBound = 'true';
    details.addEventListener('toggle', () => syncDrawer(details));
    details.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => closeDrawer(details));
    });
    syncDrawer(details);
  };

  const bindAllDrawers = () => {
    document.querySelectorAll(drawerSelector).forEach(bindDrawer);
  };

  const refreshActiveDrawer = () => {
    if (activeDrawer?.open) setDrawerTop(activeDrawer);
  };

  bindAllDrawers();
  document.addEventListener('DOMContentLoaded', bindAllDrawers, { once: true });
  document.addEventListener('shopify:section:load', bindAllDrawers);
  window.addEventListener('resize', refreshActiveDrawer, { passive: true });
  window.addEventListener('orientationchange', refreshActiveDrawer, { passive: true });
  window.visualViewport?.addEventListener('resize', refreshActiveDrawer, { passive: true });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !activeDrawer) return;
    const toggle = activeDrawer.querySelector(':scope > summary');
    closeDrawer(activeDrawer);
    toggle?.focus();
  });
})();
